import React, { useState, useEffect } from "react";
import "./Navbar.css";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BiGlobe } from "react-icons/bi";
import { FaBars, FaTimes } from "react-icons/fa";

const Navbar = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const path = location.pathname;
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Show navbar when scrolling up, hide when scrolling down
      if (currentScrollY < lastScrollY) {
        // Scrolling up
        setIsVisible(true);
      } else if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // Scrolling down and past 100px
        setIsVisible(false);
      }

      // Always show navbar at the top
      if (currentScrollY < 10) {
        setIsVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  const toggleLang = () => {
    const next = i18n.language === "en" ? "ar" : "en";
    i18n.changeLanguage(next);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  // Close mobile menu when route changes
  useEffect(() => {
    closeMobileMenu();
  }, [path]);

  return (
    <nav className={`navbar ${isVisible ? "navbar-visible" : "navbar-hidden"}`}>
      <div className="navbar-inner container">
        <div className="brand">
          <Link to="/" onClick={closeMobileMenu}>
            <img src="/pictures/star.png" alt="STARGATE Logo" className="brand-logo" />
            <span>STARGATE</span>
          </Link>
        </div>
        
        <div className="navbar-actions">
          <ul className={`nav-links ${isMobileMenuOpen ? "mobile-menu-open" : ""}`}>
            <li className={path === "/" ? "active" : ""}>
              <Link to={"/"} className="link" onClick={closeMobileMenu}>
                {t("nav.home")}
              </Link>
            </li>
            <li className={path === "/about" ? "active" : ""}>
              <Link to={"/about"} className="has-dropdown link" onClick={closeMobileMenu}>
                {t("nav.about")}
              </Link>
            </li>
            <li className={path === "/contact" ? "active" : ""}>
              <Link to={"/contact"} style={{ textDecoration: "none" }} onClick={closeMobileMenu}>
                {t("nav.contact")}
              </Link>
            </li>
          </ul>

          <button
            className="lang-toggle"
            onClick={toggleLang}
            aria-label="Toggle language"
          >
            <BiGlobe /> {i18n.language === "en" ? "EN" : "AR"}
          </button>

          <button
            className="mobile-menu-toggle"
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
            aria-expanded={isMobileMenuOpen}
          >
            {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
